export default __webpack_public_path__ + "d05464e752d50854a755773a77f13fc7.png";